// Material
import { styled } from '@mui/material/styles'
// Components
import SwitchUnstyled, { switchClasses } from '@mui/base/Switch'
import { nothing } from '$func/utils'

const Root = styled('span')`
  font-size: 0;
  position: relative;
  display: inline-block;
  width: 42px;
  height: 24px;
  padding-top: 5px;
  cursor: pointer;

  & .${switchClasses.track} {
    background: #b2b2b2;
    border-radius: 10px;
    display: block;
    height: 18px;
    width: 100%;
    position: absolute;
    transition: all 200ms ease;
  }

  & .${switchClasses.thumb} {
    display: block;
    width: 24px;
    height: 24px;
    top: -3px;
    left: -18px;
    border-radius: 12px;
    background-color: #f2f2f2;
    position: relative;
    transition: all 200ms ease;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.14), 0 2px 1px rgba(0, 0, 0, 0.12),
      0 1px 3px rgba(0, 0, 0, 0.2);
  }

  &.${switchClasses.focusVisible} .${switchClasses.thumb} {
    background-color: #b2b2b2;
    box-shadow: 0 0 1px 8px rgba(0, 0, 0, 0.25);
  }

  &.${switchClasses.checked} {
    .${switchClasses.thumb} {
      left: 0;
      top: -3px;
      background-color: ${({ theme }) => theme.palette.secondary.light};
    }

    .${switchClasses.track} {
      background-color: ${({ theme }) => theme.palette.primary500};
    }
  }

  &.${switchClasses.disabled} {
    cursor: not-allowed;

    .${switchClasses.thumb} {
      background-color: #bdbdbd;
    }

    .${switchClasses.track} {
      background-color: #d5d5d5;
    }
  }

  & .${switchClasses.input} {
    cursor: inherit;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
    z-index: 1;
    margin: 0;
  }
`

interface Props {
  checked: boolean
  disabled?: boolean
  onChange?: () => any
  readOnly?: boolean
}

export function Switch({ checked, disabled, readOnly, onChange }: Props) {
  return (
    <SwitchUnstyled
      slots={{ root: Root }}
      checked={checked}
      disabled={disabled}
      readOnly={readOnly}
      onChange={onChange}
    />
  )
}

Switch.defaultProps = {
  disabled: false,
  onChange: nothing,
  readOnly: true,
}
